import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import ActivitiesController from '../../../common/activitiesController/ActivitiesController'

class CarPricingList extends React.Component {
  state = {
    data: [],
    car_id: '',
    company_id: '',
  }
  componentDidMount() {
    if (this.props?.match?.params?.carId) {
      this.setState(
        {
          car_id: this.props?.match?.params?.carId,
        },
        () => {
          this.getData()
        }
      )
    }
    if (this.props?.match?.params?.companyId) {
      this.setState({
        company_id: this.props?.match?.params?.companyId,
      })
    }
  }

  getData = async () => {
    var that = this

    await axios
      .get(Constant.getAPI() + `/car/list-car-pricing/${this.state.car_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            data: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  deleteItem = (id) => {
    var token = `Bearer ${localStorage.getItem('loged_In_auth')}`

    axios
      .delete(Constant.getAPI() + `/car/delete-car-pricing/${id}`, {
        headers: {
          Authorization: token,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        Swal.fire({
          title: 'Price Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.getData()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleStatusChange = async (id, isActive) => {
    var data = { id, is_active: isActive }
    let that = this
    await axios
      .put(Constant.getAPI() + '/car/update-car-pricing-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          that.getData()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'state',
        label: 'Pickup Location',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return data.name_en + ' / ' + data.name_ar
          },
        },
      },
      {
        name: 'pickup',
        label: 'Drop Location',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return data.pickup_address_en + ' / ' + data.pickup_address_ar
          },
        },
      },
      {
        name: 'amount',
        label: 'Amount',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (isActive, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <Toggle
                id={id}
                checked={isActive ? true : false}
                value={isActive + ''}
                onChange={this.handleStatusChange.bind(this, id, !isActive)}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/car-pricing/add/${this.props.match.params.companyId}/${this.state.car_id}/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteItem.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Car Pricing List</h4>
                    </div>
                  </div>
                  <Link
                    to={`/car-pricing/add/${this.props.match.params.companyId}/${this.state.car_id}`}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add Pricing
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to={`/car/${this.props.match.params.companyId}`}>
                          <i className="feather">Car List</i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Car Pricing List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Car Pricing List'}
                          className="table-responsive"
                          data={this.state.data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CarPricingList
